import { axios } from '~/composables/general'

export const ipGeo = async () => {
  return axios.get('/public/geo')
    .then(res => res.data)
    .catch(() => undefined)
}